module.exports = __webpack_public_path__ + "static/assets/47f3606e8613b413c41810dbfe8c6d0b.png";